import { Loader } from '@/shared/ui/loader'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

const Donors = lazy(() => import('@/pages/donors/ui/index'))

const donorsSearchSchema = z.object({
  tab: z.enum(['admitted', 'deferred']).optional(),
})

export const Route = createFileRoute('/_protected/donors/')({
  validateSearch: donorsSearchSchema,
  // Keep the tab in the URL so the sidebar sub-items can highlight the active one.
  beforeLoad: ({ search }) => {
    if (!search.tab) {
      throw redirect({ to: '/donors', search: { tab: 'admitted' } })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Suspense fallback={<Loader />}>
      <Donors />
    </Suspense>
  )
}
